import { Country, Filters, Option, PageName } from '@utils/pageConfig/Types';
import { Periodicity } from '@components/time-period-selector/PeriodsTypes';
import { RelativePeriod } from '@components/comparison-period-selector/Types';
import { ProductType } from '@pages/product-analyzer/Product';
import { BaseTimePeriod } from '@services/FiltersTypes';
import { BaseApiParams } from '@services/Types';
import { CollectionLiveData } from '@components/collections/Model';

export type KpiData = {
  name: string;
  data?: number[];
};

export type KpiObject = {
  kpiType: string;
  kpiData: KpiData[];
};

export class ExploreTrendsStackKpiDataDto {
  kpiType: string = '';
  kpiData: KpiData[] = [];
}

export class ExportExploreTrendsStack {
  salesRecordsFound: boolean = false;
  categories: string[] = [];
  marketRevenueChangeInPercent: (number | null)[] = [];
  marketRevenueChangeAbsoluteInMillion: (number | null)[] = [];
  marketTotalRevenueInMillion: number[] = [];
  retailerRevenueChangeInPercent: (number | null)[] = [];
  retailerRevenueChangeAbsoluteInMillion: (number | null)[] = [];
  retailerTotalRevenueInMillion: number[] = [];
  marketTotalUnitInMillion: (number | null)[] = [];
  marketUnitChangeInPercent: (number | null)[] = [];
  marketUnitChangeAbsoluteInMillion: (number | null)[] = [];
  retailerTotalUnitInMillion: (number | null)[] = [];
  retailerUnitChangeInPercent: (number | null)[] = [];
  retailerUnitChangeAbsoluteInMillion: (number | null)[] = [];
  series: ExploreTrendsStackKpiDataDto[] = [];
}

export interface ExploreTrendsStackParams extends BaseApiParams, CollectionLiveData {
  clientId: number;
  productType: ProductType;
  productGroup: Option[];
  countries: Country[];
  period: string;
  comparisonPeriod: RelativePeriod | BaseTimePeriod;
  periodType: Periodicity;
  selectedGrowthType: string;
  saleType: string;
  saleFormat: string;
  appliedFilters: Filters[];
  kpi: string;
  segment: string;
  dataType: string;
  isSummary: boolean;
  pageName?: PageName;
}
